const ProductsOutlined = ({ fill = 'var(--primary-color)' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' fill='none' viewBox='0 0 30 30'>
    <path
      fill={fill}
      d='M17.5 21.25a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M23.125 5h-3.75Q17.5 5 17.5 6.875v3.75q0 1.875 1.875 1.875h3.75Q25 12.5 25 10.625v-3.75Q25 5 23.125 5m-12.5 0h-3.75Q5 5 5 6.875v3.75Q5 12.5 6.875 12.5h3.75q1.875 0 1.875-1.875v-3.75Q12.5 5 10.625 5m0 12.5h-3.75Q5 17.5 5 19.375v3.75Q5 25 6.875 25h3.75q1.875 0 1.875-1.875v-3.75q0-1.875-1.875-1.875'
    />
  </svg>
);

export default ProductsOutlined;
